import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {openBankingApi} from '../api';

export const bankBranchesKeys = {
  all: (bankCode: string) => ['bank-branches', bankCode] as const
};

export function useBankBranchesQuery(bankCode: string) {
  const client = useApiClient();
  return useQuery({
    queryKey: bankBranchesKeys.all(bankCode),
    queryFn: () => openBankingApi.fetchBranches(client, bankCode),
    enabled: !!bankCode,
    select: response => response.data
  });
}
